<template>
  <div :class="`single-card${active ? '' : ' disabled'}`" :title="title">
    <div class="icon-wrapper">
      <Icon :svg="icon" class="single-card__icon" />
    </div>
    <div class="single-card__info">
      <h3 class="single-card__title">
        {{ title }}
      </h3>
      <span>
        <Button tag="router-link" :to="routePath">
          Conoce más
        </Button>
      </span>
    </div>
  </div>
</template>
<script>
import Button from "@/components/ui/atoms/Button";
import Icon from "@/components/ui/atoms/Icon";
export default {
  components: {
    Icon,
    Button
  },
  props: {
    title: {
      type: String,
      default: "No title"
    },
    icon: {
      type: String,
      default: "default"
    },
    routePath: {
      type: String,
      default: "/"
    },
    active: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
@use "@/assets/styles/tools/_mixins.scss";

.single-card {
  display: flex;
  align-items: center;
  grid-gap: 0 1.5em;
  margin-bottom: 2em;
  .icon-wrapper {
    min-width: 100px;
    height: 100px;
    background-color: variables.$primary-color;
    border-radius: 50%;
    @include mixins.centered;
  }
  &__title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__icon {
    height: 3em;
    fill: variables.$text-inverted-color;
    margin: 0;
  }
  &.disabled {
    .icon-wrapper {
      background-color: variables.$border-color;
    }
    a {
      pointer-events: none;
      color: variables.$border-color;
      border-color: variables.$border-color;
    }
    h3 {
      color: variables.$border-color;
    }
  }
}
@media (min-width: variables.$lg) {
  .single-card {
    margin-bottom: 0;
  }
}
</style>
